import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader, CheckCircle, XCircle, Clock, RefreshCw } from 'lucide-react';
import './JobHistory.css';

function TopupHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/payments/my-payments');
      setItems(res.data || []);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return <CheckCircle className="status-icon completed" />;
      case 'failed':
      case 'cancelled':
        return <XCircle className="status-icon failed" />;
      case 'processing':
        return <Loader className="status-icon processing animate-spin" />;
      default:
        return <Clock className="status-icon pending" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'Оплачено';
      case 'failed':
      case 'cancelled':
        return 'Ошибка / Отменено';
      case 'processing':
        return 'Обработка';
      default:
        return 'Ожидание';
    }
  };

  if (loading && items.length === 0) {
    return (
      <div className="loading-state">
        <Loader className="animate-spin" size={48} />
        <p>Загрузка истории платежей...</p>
      </div>
    );
  }

  return (
    <div className="job-history">
      <div className="job-history-header">
        <h2>История платежей</h2>
        <div className="header-actions">
          <button
            className="btn btn-secondary"
            onClick={load}
            disabled={loading}
          >
            <RefreshCw className={loading ? 'animate-spin' : ''} size={16} />
            Обновить
          </button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="empty-state">
          <Clock size={48} />
          <p>У вас пока нет платежей</p>
        </div>
      ) : (
        <div className="jobs-table-container">
          <table className="jobs-table">
            <thead>
              <tr>
                <th>Статус</th>
                <th>Время</th>
                <th>Id платежа</th>
                <th>Пакет</th>
                <th>Токены</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              {items.map((payment) => (
                <tr key={payment.id} className="job-row">
                  <td className="status-cell">
                    <div className={`job-status status-${payment.status}`}>
                      {getStatusIcon(payment.status)}
                      <span className="status-text">{getStatusText(payment.status)}</span>
                    </div>
                  </td>
                  <td className="time-cell" style={{ color: '#ffffff' }}>
                    {new Date(payment.created_at).toLocaleDateString('ru-RU', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </td>
                  <td className="id-cell">
                    <code>{payment.id}</code>
                  </td>
                  <td className="model-cell">
                    <div className="model-info">
                      <span className="model-name">{payment.tariff_name || 'Разовое пополнение'}</span>
                    </div>
                  </td>
                  <td className="cost-cell" style={{ color: '#9b2ee0' }}>
                    +{payment.bonuses_to_add}
                  </td>
                  <td className="duration-cell" style={{ textAlign: 'left', color: '#ffffff' }}>
                    {payment.amount_rubles} ₽
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default TopupHistory;


